const localisation = {
  "enterEmailId" : "Enter Email Id",
  "enterPassword" : "Enter Password",
  "label.chitralekhaInfo":
    "Chitralekha is an AI-based open-source platform to perform video translation for various Indic languages. It supports automatic transcription of videos to respective text captions and translating them into subtitles, which can be proofread by Reviewers/Translators.",
  "Chitralekha": "Chitralekha",
  "label.addnewVideo":"How to add a new Video?",
  "label.Editing&ReviewTasks":"How to create Editing & Review Tasks?",
  "label.assigntasks":" How to assign the tasks?",
  "label.editTranscription":"How to edit a Transcription?",
  "label.workflow":" What is a workflow? How to set default workflow at Organization and Project levels?",
  "label.Popularhelpresources":"Popular help resources",
  "label.editTranslation":"How to edit a Translation?",
  "label.visitthehelpforum":"Visit the Wiki",
  "label.needmorehelp":"Need more help?",
  "label.askhelpcommunity":"Ask  the help Community",
  "label.getanswerfromcommunity":"Get answers from community experts",

};

export const translate = (prop) => {
  return localisation[prop];
};
